import { Block, Title } from '@/common/components';
import { Meta } from '@/common/components/head';
import { logErrorEvent } from '@/common/util/logEvent';
import { createPage, For, IntrinsicProps, Slot } from '@/common/util/templateHelpers';
import BlogPostComponent from '@/components/BlogPost';
import BlogLayout from '@/layouts/BlogLayout';
import BlogModel, { BlogPost } from '@/models/Blog';

import style from './index.module.scss';

interface BlogPageProps extends IntrinsicProps {
  posts: BlogPost[]
}

function notFound (path: string, error: any) {
  logErrorEvent(`Blog Page Error - ${path}`, true, error);

  return {
    notFound: true,
    revalidate: process.env.APP_CONFIG.REVALIDATE_INTERVAL_MEDIUM
  };
}

export async function getStaticProps () {
  const asPath = '/blog';

  let posts: BlogPost[] = [];
  let postsOffset = 0;

  while (true) {
    try {
      const result = await BlogModel.listAll(50, postsOffset);

      posts = [
        ...posts,
        ...(result as BlogPost[]),
      ];

      if ((result as BlogPost[]).length < 50) break;
      
      postsOffset += (result as BlogPost[]).length;
    } catch (error) {
      return notFound(asPath, error);
    }
  }

  const props: BlogPageProps = {
    posts
  };

  return {
    props,
    revalidate: process.env.APP_CONFIG.REVALIDATE_INTERVAL_MEDIUM
  };
}

export default createPage<BlogPageProps>('BlogPage', 
  { style }, 
  function BlogPage ({ className }, props) {
    return (
      <BlogLayout className={className}>
        <Slot name='header'>
          <Title size1 h1>Addicting Blog</Title>
        </Slot>

        <Meta 
          title='Addicting Blog'
          titleTag='Games - Free Online Games at Addicting Games'
        />

        <Block>
          <div className='BlogPage__Posts'>
            {
              For(props.posts, (post: BlogPost) => (
                <BlogPostComponent key={post.nid} href={'/blog' + post.path}>
                  <Slot name='title'>
                    {post.title}
                  </Slot>
                  <Slot name='description'>
                    <p>
                      {post.description}
                    </p>
                  </Slot>
                </BlogPostComponent>
              ))
            }
          </div>
        </Block>
      </BlogLayout>
    );
  });
